import { takeLatest, put, race, take } from "redux-saga/effects";

import { sparePartActions } from "actions/sparePartActions.js";
import { getBuyplanDetails } from "actions/buyplanDetailsActions.js";
import { getBuyplanTotals } from "actions/buyplanTotalsActions.js";
import { DELETE_DATA, GET_DATA } from "actions/apiOperations.js";
import { addNotification } from "notificationStore.js";
import i18next from "i18next";

export const deleteBuyplanItem = function*(action) {
  const { buyplanId, itemId } = action.payload;

  yield put({
    type: DELETE_DATA,
    path: `/api/buyplans/${buyplanId}/items/${itemId}`,
    actions: {
      success: sparePartActions.deleteBuyplanItemSuccess,
      failure: sparePartActions.deleteBuyplanItemFailure
    }
  });

  const { success } = yield race({
    success: take(sparePartActions.deleteBuyplanItemSuccess),
    error: take(sparePartActions.deleteBuyplanItemFailure)
  });

  if (success) {
    // Refresh buyplan details and totals after successful deletion
    yield put(getBuyplanDetails(buyplanId, '', {}, 999999, 0, true));
    yield put(getBuyplanTotals(buyplanId));
  }
};

export const watchDeleteBuyplanItem = function*() {
  yield takeLatest(sparePartActions.deleteBuyplanItem, deleteBuyplanItem);
};

export const fetchParentProducts = function*(action) {
  const { bpsbId, brandId, buyplanId } = action.payload;

  yield put({
    type: GET_DATA,
    path: `/api/parent_products/${bpsbId}`,
    actions: {
      success: sparePartActions.fetchParentProductsSuccess,
      failure: sparePartActions.fetchParentProductsFailure
    },
    params: {
      brand_id: brandId || buyplanId
    }
  });
};

export const watchFetchParentProducts = function*() {
  yield takeLatest(sparePartActions.fetchParentProducts, fetchParentProducts);
};

export const bulkRemoveItems = function*(action) {
  const { releaseId, buyplanId, warehouseId, filters } = action.payload;

  yield put({
    type: DELETE_DATA,
    path: `/api/releases/${releaseId}/bulk_remove_items.json`,
    actions: {
      success: sparePartActions.bulkRemoveItemsSuccess,
      failure: sparePartActions.bulkRemoveItemsFailure
    },
    params: {
      buyplan_id: buyplanId,
      warehouse_id: warehouseId || "",
      filters: filters
    }
  });

  const { success } = yield race({
    success: take(sparePartActions.bulkRemoveItemsSuccess),
    error: take(sparePartActions.bulkRemoveItemsFailure)
  });

  if (success) {
    addNotification({
      type: "success",
      message: i18next.t("removeAllBuyplanItems.success", "All items removed from buyplan")
    });
    // Reload to reflect the cleared state
    setTimeout(() => window.location.reload(), 1000);
  } else {
    addNotification({
      type: "error",
      message: i18next.t("removeAllBuyplanItems.error", "Failed to remove items")
    });
  }
};

export const watchBulkRemoveItems = function*() {
  yield takeLatest(sparePartActions.bulkRemoveItems, bulkRemoveItems);
};
